var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transactions-wrapper"},[_c('div',{staticClass:"appointment"},[_c('h4',[_vm._v(" Proefles op "+_vm._s(_vm.date)+" om "+_vm._s(_vm.time)+", duurt "+_vm._s(_vm.durationInHours)+" uur voor € "+_vm._s(_vm.price)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }